import { Auth } from './auth';
import { API } from './_API';

class BusinessesAPI {
    /** @param {number} id business ID */
    static async getBusiness(id) {
        return await fetch(`${API}/business/${id}?format=json`)
        .then(res => res.json())
        .then(data => {
            if (data.status !== 200) return new Error('Something went wrong')

            return data.data
        })
    }

    static async allBusinesses() {
        return await fetch(`${API}/business/?page_size=12&format=json`)
        .then(res => res.json())
        .then(data => {
            if (data.status !== 200) return new Error('Something went wrong')
            
            return data.data
        })
    }

    /**
     * @param {string | null} identifier código de municipio o null para todos
     * @param {("RES" | "TRA" | "HOS" | "TOU")} type
     * @param {number} [page=1]
     */
    static async businessesFiltered(identifier, type, page = 1) {
        const params = new URLSearchParams()

        if (identifier) params.append('municipality', identifier)
        if (type) params.append('type', type)
        params.append('page_size', '6')
        params.append('page', String(Math.max(1, page)))

        /* Barra final como en el API: /api/business/?municipality=... */
        return await fetch(`${API}/business/?${params}`)
        .then(res => res.json())
        .then(data => {
            return data.data
        })
    }

    /** 
     * @param {number} id business ID 
     * @param {("PLA" | "TRA" | "HOS" | "TOU")} type type of service: PLA="Food", TRA="Transport", HOS="Hotel", TOU="Tour"
     */
    static async getServices(id, type) {
        // OJO: el endpoint suele estar paginado en el backend.
        // Queremos mostrar "todos" los servicios del negocio para el mismo tipo.
        const params = new URLSearchParams()
        params.append('type', type)
        // Tamaño de página grande para minimizar requests; aún así manejamos paginación por si el backend limita.
        params.append('page_size', '100')

        const baseUrl = `${API}/business/${id}/service_items/?${params.toString()}`
        let next = baseUrl
        let combinedResults = []
        let firstPage = null

        while (next) {
            // Nota: `next` en DRF suele venir como URL absoluta o null.
            const res = await fetch(next)
            const payload = await res.json()

            if (payload.status !== 200) return new Error('Something went wrong')
            const pageData = payload.data

            if (!firstPage) firstPage = pageData
            combinedResults = combinedResults.concat(pageData?.results || [])
            next = pageData?.next || null
        }

        return {
            ...(firstPage || {}),
            results: combinedResults
        }
    }

    /**
     * Preview ligero: valida si existen servicios para un tipo concreto.
     * Sirve para decidir qué filtros mostrar en la UI sin traer todo.
     * @param {number} id business ID
     * @param {("PLA" | "TRA" | "HOS" | "TOU")} type
     * @returns {Promise<boolean>}
     */
    static async hasServices(id, type) {
        const params = new URLSearchParams()
        params.append('type', type)
        params.append('page_size', '1')

        const url = `${API}/business/${id}/service_items/?${params.toString()}`
        const res = await fetch(url)
        const payload = await res.json()

        if (payload.status !== 200) return false
        const pageData = payload.data
        return (pageData?.results || []).length > 0
    }

    /** @param {number} id service ID */
    static async getServiceDetails(id) {
        return await fetch(`${API}/item_business_service/${id}/`)
        .then(res => res.json())
        .then(data => {
            if (data.status !== 200) return new Error('Something went wrong')
            
            return data.data;
        })
    }

    /** @param {number} id business ID */
    static async getReviews(id) {
        let headers = {}

        if (Auth.getToken()) {
            headers = {
                Authorization: `Token ${Auth.getToken()}`
            }
        }

        return await fetch(`${API}/rating_comment?business=${id}&format=json`, { headers })
        .then(res => res.json())
        .then(data => {
            if (data.status !== 200) return new Error('Something went wrong')

            return data.data
        })
    }

    /** @param {number} id business ID */
    static async sendReview(id) {
        return await fetch(`${API}/rating_comment?business=${id}&format=json`, {
            method: "POST",
            headers: {
                Authorization: `Token ${Auth.getToken()}` 
            }
        })
        .then(res => res.json())
        .then(data => {
            if (data.status !== 200) return new Error('Something went wrong')

            return data.data
        })
    }
}

export {
    BusinessesAPI
}